module.exports = __webpack_public_path__ + "img/skip-forward.848bd777.svg";